/* === INBUS — Discount Bar — V-APRIL_09 (zero-start + cart sync + drawer-safe) === */
(function(){
  function onReady(fn){
    document.readyState !== 'loading'
      ? fn()
      : document.addEventListener('DOMContentLoaded', fn);
  }

  function nbspPct(s){ return String(s || '').replace('%', '\u202F%'); }

  function toInt(v){
    if (v == null) return 0;
    var str = String(v).trim();
    if (str === '') return 0;

    if (/^-?\d+$/.test(str)) {
      var direct = parseInt(str, 10);
      return isNaN(direct) ? 0 : direct;
    }

    var cleaned = str.replace(/\D/g, '');
    var n = parseInt(cleaned, 10);
    return isNaN(n) ? 0 : n;
  }

  function clampMin0(n){ return n < 0 ? 0 : n; }
  function ceilToMultiple(n, m){ return Math.ceil(n / m) * m; }
  function floorToMultiple(n, m){ return Math.floor(n / m) * m; }

  function isVisible(el){
    if(!el) return false;
    if(el.offsetParent !== null) return true;
    var r = el.getBoundingClientRect();
    return !!(r.width || r.height);
  }

  function getProductForm(root){
    var section = root.closest('section') || root.parentElement;
    if(section){
      var f = section.querySelector('form[action*="/cart/add"]');
      if(f) return f;
    }
    return root.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
  }

  function getCurrentVariantId(form){
    if(!form) return null;
    var el = form.querySelector('input[name="id"], select[name="id"]');
    if(!el) return null;
    var v = parseInt(el.value, 10);
    return isNaN(v) ? null : v;
  }

  function getActiveTier(effQty, tiers){
    var active = null;
    for(var i = 0; i < tiers.length; i++){
      if(effQty >= tiers[i].qty){
        active = tiers[i];
      }
    }
    return active;
  }

  function getVariantPrice(root){
    return toInt(root.getAttribute('data-inbus-base-price'));
  }

  function formatMoney(cents){
    var euros = (cents / 100).toFixed(2);
    return euros.replace('.', ',') + ' €';
  }

  function formatMoneyNoSymbol(cents){
    var euros = (cents / 100).toFixed(2);
    return euros.replace('.', ',');
  }

  function updateDerivedPriceBox(priceBox, discountedPrice){
    if(!priceBox) return;

    var volMl = toInt(priceBox.getAttribute('data-inbus-vol-ml'));
    var volG = toInt(priceBox.getAttribute('data-inbus-vol-g'));
    var veMenge = toInt(priceBox.getAttribute('data-inbus-ve-menge'));
    var veLabel = priceBox.getAttribute('data-inbus-ve-label') || 'Stk.';
    var vatDivisor = parseFloat(priceBox.getAttribute('data-inbus-vat-divisor') || '1.19');

    var pieceNetEl = priceBox.querySelector('[data-inbus-price-piece-net-value]');
    var literGrossEl = priceBox.querySelector('[data-inbus-price-liter-gross-value]');
    var literNetEl = priceBox.querySelector('[data-inbus-price-liter-net-value]');
    var kgGrossEl = priceBox.querySelector('[data-inbus-price-kg-gross-value]');
    var kgNetEl = priceBox.querySelector('[data-inbus-price-kg-net-value]');
    var veGrossEl = priceBox.querySelector('[data-inbus-price-ve-gross-value]');
    var veNetEl = priceBox.querySelector('[data-inbus-price-ve-net-value]');

    var netPieceCents = Math.round(discountedPrice / vatDivisor);

    if(pieceNetEl){
      pieceNetEl.textContent = '€' + formatMoneyNoSymbol(netPieceCents);
    }

    if(veMenge > 0 && veGrossEl){
      var veGrossCents = Math.round(discountedPrice / veMenge);
      veGrossEl.textContent = '€' + formatMoneyNoSymbol(veGrossCents) + ' / ' + veLabel;
    }

    if(veMenge > 0 && veNetEl){
      var veNetCents = Math.round(netPieceCents / veMenge);
      veNetEl.textContent = '€' + formatMoneyNoSymbol(veNetCents) + ' / ' + veLabel;
    }

    if(volMl > 0 && literGrossEl){
      var pplCents = Math.round((discountedPrice * 1000) / volMl);
      literGrossEl.textContent = '€' + formatMoneyNoSymbol(pplCents) + ' / l';
    }

    if(volMl > 0 && literNetEl){
      var netPplCents = Math.round((netPieceCents * 1000) / volMl);
      literNetEl.textContent = '€' + formatMoneyNoSymbol(netPplCents) + ' / l';
    }

    if(volG > 0 && kgGrossEl){
      var ppkCents = Math.round((discountedPrice * 1000) / volG);
      kgGrossEl.textContent = '€' + formatMoneyNoSymbol(ppkCents) + ' / kg';
    }

    if(volG > 0 && kgNetEl){
      var netPpkCents = Math.round((netPieceCents * 1000) / volG);
      kgNetEl.textContent = '€' + formatMoneyNoSymbol(netPpkCents) + ' / kg';
    }
  }

  var Q_SEL = [
    'input[name="quantity"]:not([type="hidden"]):not([disabled])',
    '.quantity__input:not([disabled])',
    'input#Quantity:not([disabled])',
    'input[id^="Quantity-"]:not([disabled])'
  ];

  function findQtyInput(form){
    if(form){
      for(var i = 0; i < Q_SEL.length; i++){
        var el = form.querySelector(Q_SEL[i]);
        if(el && isVisible(el)) return el;
      }
    }
    for(var j = 0; j < Q_SEL.length; j++){
      var el2 = document.querySelector(Q_SEL[j]);
      if(el2 && isVisible(el2)) return el2;
    }
    return null;
  }

  var cartCache = null;

  function fetchCart(){
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r){ return r.ok ? r.json() : Promise.reject(); })
      .then(function(j){ cartCache = j; return j; })
      .catch(function(){ cartCache = null; return null; });
  }

  function computeInCartQty(variantId){
    if(!variantId || !cartCache || !Array.isArray(cartCache.items)) return 0;
    var vid = toInt(variantId);
    return cartCache.items.reduce(function(sum, item){
      return sum + ((toInt(item && item.id) === vid) ? (toInt(item && item.quantity) || 0) : 0);
    }, 0);
  }

  function readTiersFromDataset(root){
    var tiers = [];
    for(var i = 1; i <= 5; i++){
      var q = toInt(root.getAttribute('data-tier-' + i + '-qty'));
      var rawVal = root.getAttribute('data-tier-' + i + '-value');
      var v = toInt(rawVal);
      if(q > 0 && v >= 0){
        tiers.push({ qty: q, value: v, label: String(v) + '%' });
      }
    }
    tiers.sort(function(a, b){ return a.qty - b.qty; });
    return tiers;
  }

  function ensureLineItemProperties(form, snapActive, threshold, step){
    if(!form) return;

    function upsert(name, value){
      var sel = 'input[name="' + name.replace(/"/g, '\\"') + '"]';
      var el = form.querySelector(sel);
      if(!el){
        el = document.createElement('input');
        el.type = 'hidden';
        el.name = name;
        form.appendChild(el);
      }
      el.value = String(value);
    }

    upsert('properties[_inbus_snap_enabled]', snapActive ? '1' : '0');

    if(snapActive){
      upsert('properties[_inbus_snap_threshold]', String(threshold));
      upsert('properties[_inbus_snap_step]', String(step));
    } else {
      upsert('properties[_inbus_snap_threshold]', '');
      upsert('properties[_inbus_snap_step]', '');
    }
  }

  function initOne(root){
    if(!root || root._inbusInit) return;
    root._inbusInit = true;

    var tiers = readTiersFromDataset(root);
    var tierCount = tiers.length;

    var nameSingular = root.getAttribute('data-inbus-name-singular') || '';
    var namePlural   = root.getAttribute('data-inbus-name-plural') || '';

    var snapEnabled = (
      String(root.getAttribute('data-inbus-snap-enabled')) === '1' ||
      String(root.getAttribute('data-inbus-snap-enabled')) === 'true'
    );

    var snapThreshold = toInt(root.getAttribute('data-inbus-snap-threshold'));
    var snapStep      = toInt(root.getAttribute('data-inbus-snap-step'));
    var snapActive    = !!(snapEnabled && snapThreshold > 0 && snapStep > 0);

    var hintLine1 = root.querySelector('.inbus-comp-product-discobar__hint-line1');
    var hintLine2 = root.querySelector('.inbus-comp-product-discobar__hint-line2');
    var track     = root.querySelector('.inbus-comp-product-discobar__track');
    var fill      = root.querySelector('.inbus-comp-product-discobar__fill');
    var labels    = root.querySelector('.inbus-comp-product-discobar__labels');

    var section = root.closest('section');
    var priceTierContainer = section ? section.querySelector('[data-inbus-pricetiers="1"]') : null;
    var priceBox = document.querySelector('[data-inbus-pricebox="1"]');

    var form = null;
    var qtyInput = null;
    var submitBtn = null;

    var inCartQty = 0;
    var lastRaw = null;
    var userTouchedQty = false;
    var lastAppliedCartQty = null;
    var isEditingQty = false;

    if(!hintLine1 || !hintLine2 || !track || !fill || !labels) return;
    
    function unitLabel(n){
      if(!nameSingular && !namePlural) return 'Aerosol' + (n === 1 ? '' : 'e');
      return n === 1 ? (nameSingular || namePlural) : (namePlural || nameSingular);
    }

    function buildBarLabels(){
      labels.innerHTML = '';
      if(!tierCount) return;

      tiers.forEach(function(tier, index){
        var item = document.createElement('div');
        item.className = 'inbus-comp-product-discobar__label';
        item.textContent = tier.label;

        var leftPct = ((2 * index + 1) / (2 * tierCount)) * 100;
        item.style.left = leftPct + '%';
        item.setAttribute('data-tier-qty', String(tier.qty));

        labels.appendChild(item);
      });
    }

    function updateBarLabels(activeTier){
      var all = labels.querySelectorAll('.inbus-comp-product-discobar__label');
      all.forEach(function(el){
        var qty = toInt(el.getAttribute('data-tier-qty'));
        var isActive = !!(activeTier && activeTier.qty === qty);
        el.classList.toggle('is-active', isActive);
      });
    }

    function updateBarFill(activeTier){
      var minPct = 7.5;
      var pct = minPct;

      if(activeTier && tierCount > 0){
        var activeIndex = -1;

        for(var i = 0; i < tiers.length; i++){
          if(tiers[i].qty === activeTier.qty){
            activeIndex = i;
            break;
          }
        }

        if(activeIndex >= 0){
          pct = ((activeIndex + 1) / tierCount) * 100;
        }
      }

      pct = Math.max(minPct, Math.min(100, pct));
      fill.style.width = pct + '%';
      fill.style.minWidth = '12px';
    }

 function renderPriceTiers(activeTier){
  if(!priceTierContainer) return;

  var list = priceTierContainer.querySelector('.inbus-comp-product-pricetiers__list');
  var head = priceTierContainer.querySelector('.inbus-comp-product-pricetiers__head');
  if(!list || !head) return;

  var basePrice = getVariantPrice(root);
  var veMenge = toInt(priceTierContainer.getAttribute('data-inbus-ve-menge'));
  var hasVE = veMenge > 0;

  list.innerHTML = '';
  head.classList.toggle('is-ve', hasVE);

  var allTiers = [{ qty: 1, value: 0, isBase: true }].concat(tiers);

  allTiers.forEach(function(tier){
    var tierPrice = basePrice;
    if(tier.value > 0){
      tierPrice = Math.round(basePrice * (100 - tier.value) / 100);
    }

    var isActive = false;
    if(activeTier){
      isActive = (tier.qty === activeTier.qty);
    } else {
      isActive = (tier.isBase === true);
    }

    var qtyText;
    var rightHtml;

    if(hasVE){
      var totalUnits = tier.qty * veMenge;
      var veUnitLabel = (tier.qty === 1)
        ? (nameSingular || namePlural || 'VE')
        : (namePlural || nameSingular || 'VE');

      qtyText = 'ab ' + tier.qty + ' ' + veUnitLabel;

      rightHtml = `
        <span class="inbus-font-product-pricetiers-cell inbus-comp-product-pricetier__pieces">${totalUnits}</span>
        <span class="inbus-font-product-pricetiers-cell inbus-comp-product-pricetier__price">${formatMoney(tierPrice)}</span>
        <span class="inbus-font-product-pricetiers-cell inbus-comp-product-pricetier__discount">${tier.value}%</span>
      `;
    } else {
      var tierUnitLabel = (tier.qty === 1)
        ? (nameSingular || namePlural || 'Stück')
        : (namePlural || nameSingular || 'Stück');

      qtyText = 'ab ' + tier.qty + ' ' + tierUnitLabel;

      rightHtml = `
        <span class="inbus-font-product-pricetiers-cell inbus-comp-product-pricetier__price">${formatMoney(tierPrice)}</span>
        <span class="inbus-font-product-pricetiers-cell inbus-comp-product-pricetier__discount">${tier.value}%</span>
      `;
    }

    var row = document.createElement('div');
    row.className = 'inbus-comp-product-pricetier';
    if(hasVE) row.classList.add('is-ve');
    if(isActive) row.classList.add('is-active');

    row.innerHTML = `
      <div class="inbus-comp-product-pricetier__left">
        <span class="inbus-comp-product-pricetier__dot"></span>
        <span class="inbus-font-product-pricetiers-cell inbus-comp-product-pricetier__qty">${qtyText}</span>
      </div>
      <div class="inbus-comp-product-pricetier__right">
        ${rightHtml}
      </div>
    `;

    list.appendChild(row);
  });
}

    function updateSubmitState(){
      if(!form || !qtyInput) return;

      submitBtn =
        form.querySelector('[type="submit"]') ||
        form.querySelector('.product-form__submit');

      if(!submitBtn) return;

      var qty = toInt(qtyInput.value);

      if(qty <= 0){
        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-disabled', 'true');
      } else {
        submitBtn.disabled = false;
        submitBtn.removeAttribute('aria-disabled');
      }
    }

    function maybeApplyZeroStart(){
      if(!qtyInput) return;

      qtyInput.setAttribute('min', '0');

      if(inCartQty > 0 && !userTouchedQty){
        qtyInput.value = '0';
        lastRaw = 0;
      }
    }

    function maybeReapplyZeroStart(force){
      if(!qtyInput) return;

      qtyInput.setAttribute('min', '0');

      var cartChanged = (inCartQty !== lastAppliedCartQty);

      if(inCartQty > 0 && (force || cartChanged)){
        if(!userTouchedQty){
          qtyInput.value = '0';
          lastRaw = 0;
        }
      }

      if(inCartQty <= 0 && force){
        if(!userTouchedQty && toInt(qtyInput.value) <= 0){
          qtyInput.value = '1';
          lastRaw = 1;
        }
      }

      lastAppliedCartQty = inCartQty;
      updateSubmitState();
    }

    buildBarLabels();

    function adjustQtyCommitted(raw){
      var s = clampMin0(toInt(raw));
      if(s === 0) return 0;
      if(!snapActive) return s;

      var total = inCartQty + s;

      if(total < snapThreshold) return s;

      return clampMin0(Math.ceil(total / snapStep) * snapStep - inCartQty);
    }

    function adjustQty(raw){
      var s = clampMin0(toInt(raw));
      if(s === 0) return 0;
      if(!snapActive) return s;

      var dir = null;

      if(lastRaw != null){
        dir = s > lastRaw ? 'up' : (s < lastRaw ? 'down' : null);
      }

      var total = inCartQty + s;

      if(total < snapThreshold) return s;

      return (dir === 'down')
        ? clampMin0(Math.max(snapThreshold, floorToMultiple(total, snapStep)) - inCartQty)
        : clampMin0(ceilToMultiple(total, snapStep) - inCartQty);
    }

    function render(force){
      if(!force && isEditingQty && qtyInput && document.activeElement === qtyInput){
        updateSubmitState();
        return;
      }

      var raw = qtyInput ? toInt(qtyInput.value) : 0;
      var adj = adjustQty(raw);

      if(qtyInput && adj !== raw){
        qtyInput.value = String(adj);
      }

      lastRaw = adj;

      var eff = inCartQty + adj;
      var activeTier = getActiveTier(eff, tiers);
      var discountPct = activeTier ? activeTier.value : 0;

      var basePrice = getVariantPrice(root);
      var discountedPrice = basePrice;

      if(discountPct > 0 && basePrice > 0){
        discountedPrice = Math.round(basePrice * (100 - discountPct) / 100);
      }

      var priceMainEl = priceBox ? priceBox.querySelector('[data-inbus-price-main]') : null;
      var priceDiscountedEl = priceBox ? priceBox.querySelector('[data-inbus-price-discounted]') : null;
      var hasDiscount = (discountPct > 0 && basePrice > 0);

      if(priceMainEl && priceDiscountedEl){
        if(hasDiscount){
          priceMainEl.classList.remove('inbus-font-product-p-price-current');
          priceMainEl.classList.add('inbus-font-product-p-price-old');
          priceDiscountedEl.textContent = formatMoney(discountedPrice);
        } else {
          priceMainEl.classList.remove('inbus-font-product-p-price-old');
          priceMainEl.classList.add('inbus-font-product-p-price-current');
          priceDiscountedEl.textContent = '';
        }
      }

      updateDerivedPriceBox(priceBox, discountedPrice);
      updateBarFill(activeTier);
      updateBarLabels(activeTier);
      renderPriceTiers(activeTier);
      updateSubmitState();

      var next = null;
      for(var t = 0; t < tiers.length; t++){
        if(eff < tiers[t].qty){
          next = tiers[t];
          break;
        }
      }

      if(next){
        var remain = next.qty - eff;
        hintLine1.textContent = 'Noch ' + remain + ' ' + unitLabel(remain);
        hintLine2.textContent = 'um ' + nbspPct(next.label) + ' zu sparen';
      } else if(tiers.length){
        hintLine1.textContent = 'Maximaler Nachlass';
        hintLine2.textContent = 'von ' + nbspPct(tiers[tierCount - 1].label) + ' erreicht';
      } else {
        hintLine1.textContent = '';
        hintLine2.textContent = '';
      }
    }

    function bindQty(){
      form = getProductForm(root);
      ensureLineItemProperties(form, snapActive, snapThreshold, snapStep);

      var found = findQtyInput(form);
      if(found && found !== qtyInput){
        qtyInput = found;
        qtyInput.setAttribute('min', '0');

        if(inCartQty > 0 && !userTouchedQty){
          qtyInput.value = '0';
          lastRaw = 0;
        }

        qtyInput.addEventListener('focus', function(){
          isEditingQty = true;
        });

        qtyInput.addEventListener('input', function(){
          userTouchedQty = true;
          isEditingQty = true;
        });

        qtyInput.addEventListener('change', function(){
          userTouchedQty = true;
        });

        qtyInput.addEventListener('blur', function(){
          userTouchedQty = true;
          isEditingQty = false;

          var committed = adjustQtyCommitted(qtyInput.value);
          qtyInput.value = String(committed);
          lastRaw = committed;

          render(true);
        });

        qtyInput.addEventListener('keydown', function(e){
          if(e.key === 'Enter'){
            e.preventDefault();
            userTouchedQty = true;
            isEditingQty = false;

            var committed = adjustQtyCommitted(qtyInput.value);
            qtyInput.value = String(committed);
            lastRaw = committed;

            render(true);
            qtyInput.blur();
          }
        });

        updateSubmitState();
      }

      if(form && !form._inbusZeroSubmitBound){
        form.addEventListener('submit', function(e){
          if(!qtyInput) return;
          if(toInt(qtyInput.value) <= 0){
            e.preventDefault();
            e.stopPropagation();
            return;
          }

          userTouchedQty = false;
        });
        form._inbusZeroSubmitBound = true;
      }
    }

    bindQty();

    var vid = getCurrentVariantId(form) || toInt(root.getAttribute('data-inbus-variant-id'));

    fetchCart().then(function(){
      inCartQty = computeInCartQty(vid);
      maybeApplyZeroStart();
      maybeReapplyZeroStart(true);
      render(true);
    });

    setInterval(function(){
      bindQty();

      if(!isEditingQty){
        render();
      }
    }, 300);

    setInterval(function(){
      fetchCart().then(function(){
        inCartQty = computeInCartQty(vid);
        maybeReapplyZeroStart(false);

        if(!isEditingQty){
          render();
        }
      });
    }, 5000);

    new MutationObserver(function(){
      bindQty();
    }).observe(document.body, { childList: true, subtree: true });
  }

  onReady(function(){
    document
      .querySelectorAll('.inbus-comp-product-discobar[data-inbus-discobar="1"]')
      .forEach(initOne);
  });
})();